import React, { useState } from "react";
// redux
import { connect } from "react-redux";

import { AiOutlineLock } from "react-icons/ai";

// bootstrap
import {
	Spinner
} from "react-bootstrap";

// styles
import {
	CartContainer,
	Heading,
	PagingLink,
	CheckoutStepsContainer
} from "../../styles/Body";

// checkout steps components
import CheckoutStepOne from '../CheckoutProcess/CheckoutStepOne'
import CheckoutStepTwo from '../CheckoutProcess/CheckoutStepTwo'
import CheckoutStepThree from '../CheckoutProcess/CheckoutStepThree'
import CartItems from "./CartItems";

function Body(props) {
	// props
	const {
		pageLoading,

		cartItems,
		cartImages,
		cartDetails,

		allCheckoutDetails,
		setAllCheckoutDetails,

		userBillingAddress,
		userShippingAddress,

		guestUserEmail
	} = props;

	// states
	const [cartLoading, setCartLoading] = useState(false);
	const [checkoutCurrentStep, setCheckoutCurrentStep] = useState("step1");
	const [completedcheckoutSteps, setCompletedCheckoutSteps] = useState([""]);
	const [showCartItems, setShowCartItems] = useState(false);

	// step 1
	const [userAddress, setUserAddress] = useState("")
	// step 2
	const [shippingMethod, setShippingMethod] = useState(null)
	// step 3
	const [paymentMethod, setPaymentMethod] = useState("")

	return (
		<CartContainer className="position-relative">
			{/* <div className="row g-5 px-2"> */}
			<div className="d-lg-flex flex-wrap align-items-start cart-container-main px-lg-2">
				{/* left part */}
				<div className="lt-sec-main media-body">
					<div className="inner position-relative">
						<div className="pb-3">
							<Heading>Checkout</Heading>
							<PagingLink>
								<span>Store</span> &ensp;/&ensp;<span>Checkout</span>
							</PagingLink>
						</div>

						<CheckoutStepsContainer>

							<div className="checkout-steps-inner">
								<CheckoutStepOne
									allCheckoutDetails={allCheckoutDetails}
									setAllCheckoutDetails={setAllCheckoutDetails}

									checkoutCurrentStep={checkoutCurrentStep}
									setCheckoutCurrentStep={setCheckoutCurrentStep}

									completedcheckoutSteps={completedcheckoutSteps}
									setCompletedCheckoutSteps={setCompletedCheckoutSteps}

									userAddress={userAddress}
									setUserAddress={setUserAddress}

									userShippingAddress={userShippingAddress}

									guestUserEmail={guestUserEmail}
								/>

								<CheckoutStepTwo
									allowedToDisplay={completedcheckoutSteps.find(item => item === "step1")}
									allCheckoutDetails={allCheckoutDetails}
									setAllCheckoutDetails={setAllCheckoutDetails}

									checkoutCurrentStep={checkoutCurrentStep}
									setCheckoutCurrentStep={setCheckoutCurrentStep}

									completedcheckoutSteps={completedcheckoutSteps}
									setCompletedCheckoutSteps={setCompletedCheckoutSteps}

									shippingMethod={shippingMethod}
									setShippingMethod={setShippingMethod}
								/>

								<CheckoutStepThree
									allowedToDisplay={completedcheckoutSteps.find(item => item === "step1") && completedcheckoutSteps.find(item => item === "step2")}
									allCheckoutDetails={allCheckoutDetails}
									setAllCheckoutDetails={setAllCheckoutDetails}

									checkoutCurrentStep={checkoutCurrentStep}
									setCheckoutCurrentStep={setCheckoutCurrentStep}

									completedcheckoutSteps={completedcheckoutSteps}
									setCompletedCheckoutSteps={setCompletedCheckoutSteps}

									paymentMethod={paymentMethod}
									setPaymentMethod={setPaymentMethod}

									userBillingAddress={userBillingAddress}
								/>

								<div className="upcoming-steps-view pt-3">
									{
										(checkoutCurrentStep !== "step3") ? (
											<p className="head st-fw-600 st-fs-22">Next</p>
										) : null
									}
									{
										/* frac */
										(completedcheckoutSteps.indexOf("step1") === -1) && (checkoutCurrentStep !== "step1") ? (
											<React.Fragment>
												<div className="frac">
													<div className="frac-inner">
														<p className="head st-fs-16 st-fw-600">Delivery options</p>
														<p className="desc mb-0">Select how you’ll be receiving your order.</p>
													</div>
												</div>
											</React.Fragment>
										) : null
									}

									{
										/* frac */
										(completedcheckoutSteps.indexOf("step2") === -1) && (checkoutCurrentStep !== "step2") ? (
											<React.Fragment>
												<div className="frac">
													<div className="frac-inner">
														<p className="head st-fs-16 st-fw-600">Delivery information</p>
														<p className="desc mb-0">Specify your details to choose a shipping method.</p>
													</div>
												</div>
											</React.Fragment>
										) : null
									}

									{
										/* frac */
										(completedcheckoutSteps.indexOf("step3") === -1) && (checkoutCurrentStep !== "step3") ? (
											<React.Fragment>
												<div className="frac">
													<div className="frac-inner">
														<p className="head st-fs-16 st-fw-600">Payment information</p>
														<p className="desc mb-0">Choose a payment method and enter your credentials.</p>
													</div>
												</div>
											</React.Fragment>
										) : null
									}
								</div>
							</div>

						</CheckoutStepsContainer>
					</div>
				</div>

				<div className="rt-sec-main">
					<div className="inner">
						{/* head */}
						<div className="header-part mb-3">
							<p className="d-flex align-items-center st-fs-17 st-fw-600 mb-0">
								<AiOutlineLock className="position-relative" style={{ top: -1 }} />
								<span className="ms-2">Cart Summary</span>
							</p>
						</div>

						<div className="content">
							{
								cartItems?.length ? (
									<React.Fragment>
										{/* frac */}
										<div className="frac d-flex st-fs-15 mb-2">
											<div className="lt">
												<p className="mb-0 text-capitalize">
													sub total
												</p>
											</div>
											<div className="rt ps-2 ms-auto">
												<p className="mb-0 st-fw-800">
													{cartDetails?.cart_sub_total}
												</p>
											</div>
										</div>

										{/* frac */}
										<div className="frac d-flex st-fs-15 mb-2">
											<div className="lt">
												<p className="mb-0 text-capitalize">
													discount
												</p>
											</div>
											<div className="rt ps-2 ms-auto">
												<p className="mb-0 st-fw-800 text-danger">
													{cartDetails?.cart_discount}
												</p>
											</div>
										</div>

										{/* frac */}
										<div className="frac d-flex st-fs-15 mb-2">
											<div className="lt">
												<p className="mb-0 text-capitalize">
													Shipping
												</p>
											</div>
											<div className="rt ps-2 ms-auto">
												<p className="mb-0 st-fw-800">
												{cartDetails?.allCartData?.shipping_amount_currency ?? "$0.00"}
												</p>
											</div>
										</div>

										{/* frac */}
										<div className="frac d-flex st-fs-15 mb-2">
											<div className="lt">
												<p className="mb-0 text-capitalize">
													estimated tax
												</p>
											</div>
											<div className="rt ps-2 ms-auto">
												<p className="mb-0 st-fw-800">
													{cartDetails?.cart_tax ?? "$0.00"}
												</p>
											</div>
										</div>

										{/* cart items */}
										<div className="frac cart-items">
											<div className="overflow-auto mb-2" style={{ maxHeight: 250 }}>
												{
													showCartItems ? (
														<div className="cart-listing pt-2">
															<CartItems
																cartItems={cartItems}
																cartImages={cartImages}
															/>
														</div>
													) : null
												}
											</div>
											<a href="/" className="st-fs-13" onClick={ev => {
												ev.preventDefault()
												setShowCartItems(!showCartItems) // cart items toggle
											}}>
												{
													showCartItems ? "(Hide cart items)" : "(Show cart items)"
												}
											</a>
										</div>

										{/* frac */}
										<div className="frac d-flex mb-2 main-total border-top pt-3 mt-3 st-fs-17">
											<div className="lt">
												<p className="mb-0 st-fw-800 text-capitalize">
													Total
												</p>
											</div>
											<div className="rt ps-2 ms-auto">
												<p className="mb-0 st-fw-800">
													{cartDetails?.cart_total}
												</p>
											</div>
										</div>

										{
											cartDetails?.coupon_code ? (
												<div className="frac d-flex mb-2 promo-code">
													<div className="lt">
														<p className="mb-0 st-fw-800 text-capitalize">
															Promo Code
														</p>
													</div>
													<div className="rt ps-2 ms-auto">
														<p className="mb-0 st-fw-800">
															{cartDetails.coupon_code}
															{/* <span className="text-danger ms-2 st-fw-400 st-fs-13 cursor-pointer">Delete</span> */}
														</p>
													</div>
												</div>
											) : null
										}
									</React.Fragment>
								) : (
									<React.Fragment>
										{
											!cartLoading ? (
												<p className="st-fs-17 mb-0">
													No items in the cart
												</p>
											) : null
										}
									</React.Fragment>
								)
							}

						</div>
					</div>
				</div>
			</div>

			{
				pageLoading ? (
					<div className="cart-loading position-absolute d-flex justify-content-center align-items-center" >
						<Spinner animation="border" />
					</div>
				) : null
			}
		</CartContainer>
	);
}

const getDataFromStore = (state) => {
	return {
		cartItems: state.cart.cartItems,
		cartImages: state.cart.cartImages,
		cartDetails: state.cart.cartDetails,
	};
};

// const dispatchActionsToProps = (dispatch) => {
// 	return {
// 		function: (value) => dispatch(function(value)),
// 	};
// };

export default connect(getDataFromStore, null)(Body);